'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var reactHookForm = require('react-hook-form');
var Button = require('@circlefin/components/lib/Button');

/**
 * Create Form Submit Button.
 */ function createFormSubmitButton() {
    const FormSubmitButton = ({ ...props })=>{
        const { formState } = reactHookForm.useFormContext();
        const disabled = react.useMemo(()=>props.disabled === true || !formState.isValid, [
            formState,
            props.disabled
        ]);
        const loading = react.useMemo(()=>formState.isSubmitting || props.loading, [
            formState,
            props.loading
        ]);
        return jsxRuntime.jsx(Button.Button, {
            ...props,
            disabled: disabled,
            loading: loading,
            type: "submit"
        });
    };
    FormSubmitButton.displayName = 'Form.SubmitButton';
    return FormSubmitButton;
}

exports.createFormSubmitButton = createFormSubmitButton;
//# sourceMappingURL=Form.SubmitButton.js.map
